import React from "react";
import { Link } from "@quintype/components";
import { string, object, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { getHeadline } from "../../utils/utils";

import LiveText from "../LiveText";

import "./liveNewsHeadline.m.css";

const LiveNewsHeadline = ({ story, cssStyleName, showDot = false, styles = {}, lang, Htag = "h3" }) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const storyHeadline = getHeadline(story);

  return (
    <Htag styleName={`title ${cssStyleName || ""}`} className="headline-title live-headline-title">
      <Link aria-label={story.headline} href={story.url} styleName="title-link">
        {isClosed && showDot && styles ? (
          <span
            styleName="s-dot"
            style={{ background: styles.dotColor.color !== "4d" ? styles.dotColor.color : "#ccc" }}
          >
            &nbsp;
          </span>
        ) : isClosed ? (
          ""
        ) : (
          <LiveText story={story} titleText={storyHeadline} lang={lang} />
        )}
        {isClosed && <span className="live-text-with-title">{storyHeadline}</span>}
      </Link>
    </Htag>
  );
};

LiveNewsHeadline.propTypes = {
  story: object,
  cssStyleName: string,
  showDot: bool,
  styles: object,
  lang: string,
  Htag: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(LiveNewsHeadline);
